export interface ICoupon {
  active?: boolean;
  uses?: string | number;
  duration?: number | string;
  discountActual?: string | number;
  code?: string;
  discount?: string | number;
  type?: string;
  id?: string;
  name?: string;
  old_id?: string;
  gid?: string;
  discount_type?: string;
  created?: string;
  organizationId?: string | null;
  systemOldId?: string;
  /** Whether the coupon can only be applied via admin assignment. */
  assignmentOnly?: boolean;
  /**
   * 7-bit weekday bitmask, bit 0 = Monday ... bit 6 = Sunday.
   * null/0 = valid on all days.
   */
  validDays?: number | null;
  /** Minutes since local midnight (0-1439) when the coupon becomes valid. */
  validTimeStart?: number | null;
  /** Minutes since local midnight (0-1439) when the coupon stops being valid. */
  validTimeEnd?: number | null;
  /** Date (ISO YYYY-MM-DD) from which the coupon is valid. */
  validFrom?: string | null;
  /** Date (ISO YYYY-MM-DD) until which the coupon is valid. */
  validUntil?: string | null;
}

export interface ICouponAdd {
  name: string;
  code: string;
  active: boolean;
  discount_type: string;
  discount: number;
  duration: string;
  uses: number;
}

export interface ICouponEdit {
  id: string;
  name: string;
  active: boolean;
}

export enum ECoupon {
  PERCENT = 'percent',
  TYPE = 'time',
  ONE_USE = ' Use',
  MULTIPLE_USE = ' Uses',
}
